"use strict";
/**
 * Created by Jerker Nord on 2016-04-13.
 * Refactored by Ning Jiang on 2016-12-6.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicEngine = void 0;
const gsap_1 = require("gsap");
const Helper_1 = require("../../../utils/Helper");
class BasicEngine {
    set stepDistance(value) {
        this._stepDistance = value ? (value + this.Config.STEP_DISTANCE_PADDING_Y) : this.defaultStep;
    }
    get stepDistance() {
        const distance = this._stepDistance == undefined || this._stepDistance == 0 ? this.defaultStep : this._stepDistance;
        return (this.reverse ? -1 : 1) * Math.abs(distance);
    }
    get yPos() {
        return this._yPos;
    }
    set yPos(value) {
        if (value === this._yPos) {
            return;
        }
        this._yPos = value;
        this._animateContainer.y = this._yPos;
    }
    get duration() { return this._duration; }
    set duration(value) {
        if (!this.stepDistance)
            this.stepDistance = this.defaultStep;
        this._timeScale = Math.abs(this.defaultStep / this.stepDistance);
        this._duration = value / this._timeScale;
    }
    set startSpeed(value) {
        this.configDuration.START = value;
    }
    set stopSpeed(value) {
        this.configDuration.STOP = value;
    }
    set spinSpeed(value) {
        this.configDuration.SPIN = value;
    }
    set quickStopSpeed(value) {
        this.configDuration.QUICK_STOP = value;
    }
    set Steps(value) {
        this._steps = value;
    }
    get Steps() {
        return this._steps;
    }
    get defaultStep() {
        return this.Config.STEP_DISTANCE + this.Config.STEP_DISTANCE_PADDING_Y;
    }
    set reverse(value) {
        this._reverse = value;
    }
    get reverse() {
        return this._reverse;
    }
    constructor(callbacks) {
        this._activeTimeline = new gsap_1.TimelineMax();
        this._yPos = 0;
        this._steps = 0;
        this._stepDistance = 0;
        this._duration = 0;
        this._timeScale = 1;
        this._reverse = false;
        this._callbacks = callbacks;
    }
    setConfig(config) {
        this._config = config;
    }
    get Config() {
        return this._config;
    }
    get callbacks() {
        return this._callbacks;
    }
    get configDuration() {
        return this._config.DURATION;
    }
    get configDelay() {
        return this._config.DELAY;
    }
    get configEase() {
        return this._config.EASING;
    }
    get overflowAmount() {
        return this._config.OVERFLOW_BOTT + this._config.OVERFLOW_TOP + this._config.RESULT_OVERFLOW;
    }
    get activeTimeline() {
        return this._activeTimeline;
    }
    set activeTimeline(value) {
        this._activeTimeline = value;
    }
    get nextTimeline() {
        return this._nextTimeline;
    }
    set nextTimeline(value) {
        this._nextTimeline = value;
    }
    get isActive() {
        return this.activeTimeline != undefined;
    }
    activateNextAnimation() {
        Helper_1.Helper.timeLineNuller(this.activeTimeline);
        this.activeTimeline = this.nextTimeline;
        this.activeTimeline.play();
        this.nextTimeline = null;
    }
}
exports.BasicEngine = BasicEngine;
//# sourceMappingURL=BasicEngine.js.map